import { DefaultControl } from '../types';

const blockControls: DefaultControl[] = [
    { label: 'UL', style: 'unordered-list-item', icon: 'properties' },
    { label: 'OL', style: 'ordered-list-item', icon: 'numbered-list' },
];

export default blockControls;
